import { useEffect, useRef, useState } from "react";

export function useInView(options = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect(); // 한 번만 감지
        }
      },
      {
        root: null,
        threshold: options.threshold || 0,
        rootMargin: options.rootMargin || "300px 0px", // ← 미리 로딩 여유 공간
      }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [options.threshold, options.rootMargin]);

  return [ref, inView];
}
